import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'prettyPhoneNumber'
})
export class PrettyPhoneNumberPipe implements PipeTransform {
	transform(telNumber: string, args?: any): any {
		if (!telNumber) {
			return '';
		}

		const phoneNumber = telNumber.toString().trim().replace(/^\+/, '');
		if (phoneNumber.match(/[^0-9]/)) {
			return phoneNumber;
		}

		let country, city, number;
		switch (phoneNumber.length) {
			case 10: // +1PPP####### -> C (PPP) ###-####
				country = 1;
				city = phoneNumber.slice(0, 3);
				number = phoneNumber.slice(3);
				break;

			case 11: // +CPPP####### -> CCC (PP) ###-####
				country = phoneNumber[0];
				city = phoneNumber.slice(1, 4);
				number = phoneNumber.slice(4);
				break;

			case 12: // +CCCPP####### -> CCC (PP) ###-####
				country = phoneNumber.slice(0, 3);
				city = phoneNumber.slice(3, 5);
				number = phoneNumber.slice(5);
				break;

			default:
				return phoneNumber;
		}

		if (country === 1) {
			country = '';
		}

		number = number.slice(0, 3) + '-' + number.slice(3);
		return (country + '(' + city + ') ' + number).trim();
	}
}
